import { ApiFail } from './ApiFail';

export class RequestAbortedFail extends ApiFail {}
